/**
 * Country landing-page slugs — the single source for /topup/<slug> and
 * /esim/<slug> URLs, shared by the server (route interception, SSR meta,
 * sitemap) and the client bundle (page routing).
 *
 * ranked: true = the URL existed on the legacy site and is indexed; these
 * slugs must NEVER be renamed. Unranked entries are Reloadly-active
 * countries that never had a page (listed in the sitemap only when the new
 * shell serves them, i.e. NEW_HOME=1).
 */

const COUNTRY_SLUGS = {
  'afghanistan': { iso: 'AF', name: 'Afghanistan', ranked: true },
  'albania': { iso: 'AL', name: 'Albania', ranked: true },
  'algeria': { iso: 'DZ', name: 'Algeria', ranked: true },
  'angola': { iso: 'AO', name: 'Angola', ranked: true },
  'anguilla': { iso: 'AI', name: 'Anguilla', ranked: true },
  'antigua': { iso: 'AG', name: 'Antigua', ranked: true },
  'argentina': { iso: 'AR', name: 'Argentina', ranked: true },
  'armenia': { iso: 'AM', name: 'Armenia', ranked: true },
  'aruba': { iso: 'AW', name: 'Aruba', ranked: true },
  'australia': { iso: 'AU', name: 'Australia' },
  'austria': { iso: 'AT', name: 'Austria' },
  'azerbaijan': { iso: 'AZ', name: 'Azerbaijan', ranked: true },
  'bahrain': { iso: 'BH', name: 'Bahrain', ranked: true },
  'bangladesh': { iso: 'BD', name: 'Bangladesh', ranked: true },
  'barbados': { iso: 'BB', name: 'Barbados', ranked: true },
  'belarus': { iso: 'BY', name: 'Belarus', ranked: true },
  'belgium': { iso: 'BE', name: 'Belgium' },
  'belize': { iso: 'BZ', name: 'Belize', ranked: true },
  'benin': { iso: 'BJ', name: 'Benin', ranked: true },
  'bermuda': { iso: 'BM', name: 'Bermuda', ranked: true },
  'bhutan': { iso: 'BT', name: 'Bhutan', ranked: true },
  'bolivia': { iso: 'BO', name: 'Bolivia', ranked: true },
  'botswana': { iso: 'BW', name: 'Botswana', ranked: true },
  'brazil': { iso: 'BR', name: 'Brazil', ranked: true },
  'british-virgin-islands': { iso: 'VG', name: 'British Virgin Islands', ranked: true },
  'burkina-faso': { iso: 'BF', name: 'Burkina Faso', ranked: true },
  'burundi': { iso: 'BI', name: 'Burundi', ranked: true },
  'cambodia': { iso: 'KH', name: 'Cambodia', ranked: true },
  'cameroon': { iso: 'CM', name: 'Cameroon', ranked: true },
  'canada': { iso: 'CA', name: 'Canada', ranked: true },
  'cape-verde': { iso: 'CV', name: 'Cape Verde', ranked: true },
  'cayman-islands': { iso: 'KY', name: 'Cayman Islands', ranked: true },
  'central-african-republic': { iso: 'CF', name: 'Central African Republic', ranked: true },
  'chile': { iso: 'CL', name: 'Chile', ranked: true },
  'china': { iso: 'CN', name: 'China', ranked: true },
  'colombia': { iso: 'CO', name: 'Colombia', ranked: true },
  'comoros': { iso: 'KM', name: 'Comoros', ranked: true },
  'costa-rica': { iso: 'CR', name: 'Costa Rica', ranked: true },
  'cuba': { iso: 'CU', name: 'Cuba', ranked: true },
  'curacao': { iso: 'CW', name: 'Curacao', ranked: true },
  'cyprus': { iso: 'CY', name: 'Cyprus', ranked: true },
  'democratic-republic-of-the-congo': { iso: 'CD', name: 'Democratic Republic of the Congo', ranked: true },
  'dominica': { iso: 'DM', name: 'Dominica', ranked: true },
  'dominican-republic': { iso: 'DO', name: 'Dominican Republic', ranked: true },
  'ecuador': { iso: 'EC', name: 'Ecuador', ranked: true },
  'egypt': { iso: 'EG', name: 'Egypt', ranked: true },
  'el-salvador': { iso: 'SV', name: 'El Salvador', ranked: true },
  'ethiopia': { iso: 'ET', name: 'Ethiopia', ranked: true },
  'fiji': { iso: 'FJ', name: 'Fiji', ranked: true },
  'france': { iso: 'FR', name: 'France', ranked: true },
  'french-guiana': { iso: 'GF', name: 'French Guiana', ranked: true },
  'gabon': { iso: 'GA', name: 'Gabon', ranked: true },
  'gambia': { iso: 'GM', name: 'Gambia', ranked: true },
  'georgia': { iso: 'GE', name: 'Georgia', ranked: true },
  'germany': { iso: 'DE', name: 'Germany', ranked: true },
  'ghana': { iso: 'GH', name: 'Ghana', ranked: true },
  'greece': { iso: 'GR', name: 'Greece' },
  'grenada': { iso: 'GD', name: 'Grenada', ranked: true },
  'guadeloupe': { iso: 'GP', name: 'Guadeloupe', ranked: true },
  'guatemala': { iso: 'GT', name: 'Guatemala', ranked: true },
  'guinea': { iso: 'GN', name: 'Guinea', ranked: true },
  'guinea-bissau': { iso: 'GW', name: 'Guinea-Bissau', ranked: true },
  'guyana': { iso: 'GY', name: 'Guyana', ranked: true },
  'haiti': { iso: 'HT', name: 'Haiti', ranked: true },
  'honduras': { iso: 'HN', name: 'Honduras', ranked: true },
  'india': { iso: 'IN', name: 'India', ranked: true },
  'indonesia': { iso: 'ID', name: 'Indonesia', ranked: true },
  'iraq': { iso: 'IQ', name: 'Iraq', ranked: true },
  'ireland': { iso: 'IE', name: 'Ireland', ranked: true },
  'israel': { iso: 'IL', name: 'Israel' },
  'italy': { iso: 'IT', name: 'Italy', ranked: true },
  'ivory-coast': { iso: 'CI', name: 'Ivory Coast', ranked: true },
  'jamaica': { iso: 'JM', name: 'Jamaica', ranked: true },
  'japan': { iso: 'JP', name: 'Japan' },
  'jordan': { iso: 'JO', name: 'Jordan', ranked: true },
  'kenya': { iso: 'KE', name: 'Kenya', ranked: true },
  'kosovo': { iso: 'XK', name: 'Kosovo', ranked: true },
  'kuwait': { iso: 'KW', name: 'Kuwait', ranked: true },
  'kyrgyzstan': { iso: 'KG', name: 'Kyrgyzstan', ranked: true },
  'laos': { iso: 'LA', name: 'Laos', ranked: true },
  'lebanon': { iso: 'LB', name: 'Lebanon' },
  'liberia': { iso: 'LR', name: 'Liberia', ranked: true },
  'lithuania': { iso: 'LT', name: 'Lithuania', ranked: true },
  'macedonia': { iso: 'MK', name: 'Macedonia', ranked: true },
  'madagascar': { iso: 'MG', name: 'Madagascar', ranked: true },
  'malawi': { iso: 'MW', name: 'Malawi', ranked: true },
  'malaysia': { iso: 'MY', name: 'Malaysia', ranked: true },
  'mali': { iso: 'ML', name: 'Mali', ranked: true },
  'martinique': { iso: 'MQ', name: 'Martinique', ranked: true },
  'mauritania': { iso: 'MR', name: 'Mauritania' },
  'mexico': { iso: 'MX', name: 'Mexico', ranked: true },
  'moldova': { iso: 'MD', name: 'Moldova', ranked: true },
  'montserrat': { iso: 'MS', name: 'Montserrat', ranked: true },
  'morocco': { iso: 'MA', name: 'Morocco', ranked: true },
  'mozambique': { iso: 'MZ', name: 'Mozambique', ranked: true },
  'myanmar': { iso: 'MM', name: 'Myanmar', ranked: true },
  'namibia': { iso: 'NA', name: 'Namibia' },
  'nauru': { iso: 'NR', name: 'Nauru', ranked: true },
  'nepal': { iso: 'NP', name: 'Nepal', ranked: true },
  'netherlands': { iso: 'NL', name: 'Netherlands' },
  'netherlands-antilles': { iso: 'AN', name: 'Netherlands Antilles', ranked: true },
  'nicaragua': { iso: 'NI', name: 'Nicaragua', ranked: true },
  'niger': { iso: 'NE', name: 'Niger', ranked: true },
  'nigeria': { iso: 'NG', name: 'Nigeria', ranked: true },
  'oman': { iso: 'OM', name: 'Oman' },
  'pakistan': { iso: 'PK', name: 'Pakistan', ranked: true },
  'palestine': { iso: 'PS', name: 'Palestine', ranked: true },
  'panama': { iso: 'PA', name: 'Panama', ranked: true },
  'papua-new-guinea': { iso: 'PG', name: 'Papua New Guinea', ranked: true },
  'paraguay': { iso: 'PY', name: 'Paraguay', ranked: true },
  'peru': { iso: 'PE', name: 'Peru', ranked: true },
  'philippines': { iso: 'PH', name: 'Philippines', ranked: true },
  'poland': { iso: 'PL', name: 'Poland', ranked: true },
  'portugal': { iso: 'PT', name: 'Portugal', ranked: true },
  'puerto-rico': { iso: 'PR', name: 'Puerto Rico', ranked: true },
  'qatar': { iso: 'QA', name: 'Qatar', ranked: true },
  'republic-of-the-congo': { iso: 'CG', name: 'Republic of the Congo', ranked: true },
  'romania': { iso: 'RO', name: 'Romania', ranked: true },
  'russia': { iso: 'RU', name: 'Russia', ranked: true },
  'rwanda': { iso: 'RW', name: 'Rwanda', ranked: true },
  'samoa': { iso: 'WS', name: 'Samoa', ranked: true },
  'saudi-arabia': { iso: 'SA', name: 'Saudi Arabia', ranked: true },
  'senegal': { iso: 'SN', name: 'Senegal', ranked: true },
  'sierra-leone': { iso: 'SL', name: 'Sierra Leone', ranked: true },
  'singapore': { iso: 'SG', name: 'Singapore', ranked: true },
  'somaliland': { iso: 'SO', name: 'Somaliland', ranked: true },
  'south-africa': { iso: 'ZA', name: 'South Africa', ranked: true },
  'south-korea': { iso: 'KR', name: 'South Korea' },
  'spain': { iso: 'ES', name: 'Spain', ranked: true },
  'sri-lanka': { iso: 'LK', name: 'Sri Lanka', ranked: true },
  'st-kitts-and-nevis': { iso: 'KN', name: 'St. Kitts & Nevis' },
  'st-lucia': { iso: 'LC', name: 'St. Lucia' },
  'st-vincent-and-grenadines': { iso: 'VC', name: 'St. Vincent & Grenadines' },
  'sudan': { iso: 'SD', name: 'Sudan', ranked: true },
  'suriname': { iso: 'SR', name: 'Suriname', ranked: true },
  'swaziland': { iso: 'SZ', name: 'Swaziland', ranked: true },
  'switzerland': { iso: 'CH', name: 'Switzerland' },
  'tajikistan': { iso: 'TJ', name: 'Tajikistan', ranked: true },
  'tanzania': { iso: 'TZ', name: 'Tanzania', ranked: true },
  'thailand': { iso: 'TH', name: 'Thailand', ranked: true },
  'the-bahamas': { iso: 'BS', name: 'The Bahamas', ranked: true },
  'togo': { iso: 'TG', name: 'Togo', ranked: true },
  'tonga': { iso: 'TO', name: 'Tonga', ranked: true },
  'trinidad-and-tobago': { iso: 'TT', name: 'Trinidad & Tobago', ranked: true },
  'tunisia': { iso: 'TN', name: 'Tunisia', ranked: true },
  'turkey': { iso: 'TR', name: 'Turkey', ranked: true },
  'turks-and-caicos': { iso: 'TC', name: 'Turks and Caicos', ranked: true },
  'uganda': { iso: 'UG', name: 'Uganda', ranked: true },
  'ukraine': { iso: 'UA', name: 'Ukraine', ranked: true },
  'united-arab-emirates': { iso: 'AE', name: 'United Arab Emirates', ranked: true },
  'united-kingdom': { iso: 'GB', name: 'United Kingdom', ranked: true },
  'united-states': { iso: 'US', name: 'United States', ranked: true },
  'uruguay': { iso: 'UY', name: 'Uruguay', ranked: true },
  'uzbekistan': { iso: 'UZ', name: 'Uzbekistan', ranked: true },
  'vanuatu': { iso: 'VU', name: 'Vanuatu', ranked: true },
  'venezuela': { iso: 'VE', name: 'Venezuela' },
  'vietnam': { iso: 'VN', name: 'Vietnam', ranked: true },
  'yemen': { iso: 'YE', name: 'Yemen', ranked: true },
  'zambia': { iso: 'ZM', name: 'Zambia', ranked: true },
  'zimbabwe': { iso: 'ZW', name: 'Zimbabwe', ranked: true },
};

// Canonical slug per ISO (the map is 1:1 today).
const SLUG_BY_ISO = {};
for (const [slug, v] of Object.entries(COUNTRY_SLUGS)) {
  if (!SLUG_BY_ISO[v.iso]) SLUG_BY_ISO[v.iso] = slug;
}

function findBySlug(slug) {
  const v = COUNTRY_SLUGS[String(slug || '').toLowerCase()];
  return v ? { slug: String(slug).toLowerCase(), iso: v.iso, name: v.name } : null;
}

// Common alternate names → canonical slug. ISO codes (/topup/us, /esim/de)
// are resolved generically in resolveSlugAlias, so only names go here.
const SLUG_ALIASES = {
  usa: 'united-states',
  america: 'united-states',
  'united-states-of-america': 'united-states',
  uk: 'united-kingdom',
  england: 'united-kingdom',
  britain: 'united-kingdom',
  'great-britain': 'united-kingdom',
  uae: 'united-arab-emirates',
  emirates: 'united-arab-emirates',
  drc: 'democratic-republic-of-the-congo',
  congo: 'republic-of-the-congo',
  burma: 'myanmar',
  eswatini: 'swaziland',
  'cabo-verde': 'cape-verde',
  'north-macedonia': 'macedonia',
  'cote-divoire': 'ivory-coast',
  'cote-d-ivoire': 'ivory-coast',
  korea: 'south-korea',
  holland: 'netherlands',
  bahamas: 'the-bahamas',
  'saint-lucia': 'st-lucia',
  'saint-kitts-and-nevis': 'st-kitts-and-nevis',
  'saint-vincent-and-grenadines': 'st-vincent-and-grenadines',
  // Legacy dot-format slugs (dots stripped during normalization):
  // /topup/St.-Kitts → st-kitts, /topup/St.-Lucia → st-lucia, etc.
  'st-kitts': 'st-kitts-and-nevis',
  'st-vincent': 'st-vincent-and-grenadines',
};

/**
 * Canonical slug for an alias, or null when the slug is already canonical
 * (or unknown). Aliases: 2-letter ISO codes and SLUG_ALIASES names — the
 * routes 301 these to the canonical landing URL.
 */
function resolveSlugAlias(slug) {
  const s = String(slug || '').toLowerCase();
  if (COUNTRY_SLUGS[s]) return null;
  if (SLUG_ALIASES[s] && COUNTRY_SLUGS[SLUG_ALIASES[s]]) return SLUG_ALIASES[s];
  if (/^[a-z]{2}$/.test(s)) {
    const canonical = SLUG_BY_ISO[s.toUpperCase()];
    if (canonical) return canonical;
  }
  return null;
}

module.exports = { COUNTRY_SLUGS, SLUG_BY_ISO, findBySlug, resolveSlugAlias };
